import React from 'react';
import { Link } from 'gatsby';
import Layout from '../components/layout';

const Success = () => (
  <Layout>
    <div className="error-section">
      <div className="container">
        <div className="row justify-content-end">
          <div className="offset-xl-1 col-xl-5 col-lg-6 col-md-12 col-sm-12 col-12 ">
            {/* error block start */}
            <div className="error-block">
              <h1 className="error-sub-title fontweight-bold">Message Sent</h1>
              <p>
              We appreciate you contacting us. One of our colleagues will get back to you shortly.
                <br />
              Have a great day!
              </p>
              <Link to="/" className="btn btn-brand btn-rounded btn-lg ">Back to Home</Link>
            </div>
            {/* error block close */}
          </div>
        </div>
      </div>
    </div>

  </Layout>
);

export default Success;
